import React from 'react';
import BikeCard from 'components/BikeCard';
import { useSelector } from 'react-redux';
import { getBikeModel, getOfferBanner } from 'src/redux/app/selectors';
import OrderDetails from 'components/OrderDetails';
import OfferBanner from 'components/OfferBanner';
import FinanceOptionSummary from 'components/FinanceOptionSummary';

const StepFour = () => {
  const bikeModel = useSelector(getBikeModel);
  const offerBanner = useSelector(getOfferBanner);

  return (
    <>
      <BikeCard bikeModel={bikeModel}></BikeCard>
      {offerBanner && <OfferBanner offerBanner={offerBanner}></OfferBanner>}
      <FinanceOptionSummary isSummaryPage></FinanceOptionSummary>
      <OrderDetails></OrderDetails>
    </>
  );
};

export default StepFour;
